import type { Attachment } from '../../types';
import { resolveIcon } from '../../lib/icons';

export function AttachmentTile({ attachment }: { attachment: Attachment }) {
  const Icon = resolveIcon(attachment.symbol);
  return (
    <div className="flex flex-col items-center gap-2 w-[110px] shrink-0">
      <div
        className="w-[110px] h-[110px] rounded-2xl flex items-center justify-center"
        style={{ background: `${attachment.colorHex}29` }}
      >
        <Icon size={34} strokeWidth={2.2} color={attachment.colorHex} />
      </div>
      <span className="text-xs truncate max-w-[110px]">{attachment.title}</span>
    </div>
  );
}
